import { render, staticRenderFns } from "./laborCompanyCommittee.vue?vue&type=template&id=eafbbd06"
import script from "./laborCompanyCommittee.vue?vue&type=script&lang=js"
export * from "./laborCompanyCommittee.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('eafbbd06')) {
      api.createRecord('eafbbd06', component.options)
    } else {
      api.reload('eafbbd06', component.options)
    }
    module.hot.accept("./laborCompanyCommittee.vue?vue&type=template&id=eafbbd06", function () {
      api.rerender('eafbbd06', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sai/osh/laborCompanyCommittee.vue"
export default component.exports